import React, { useState } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import api from '@/api';
import { toast } from 'sonner';

const ResetPassword = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password.length < 8) {
      toast.error('Password must be at least 8 characters');
      return;
    }
    if (password !== confirm) {
      toast.error('Passwords do not match');
      return;
    }
    setLoading(true);
    try {
      await api.post('/auth/reset-password', { token, password });
      toast.success('Password reset! Logging in…');
      setTimeout(() => navigate('/login'), 1200);
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Reset failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <div className="max-w-md w-full">
        <div className="text-center mb-8">
          <div className="flex items-center justify-center gap-2 mb-6">
            <div className="w-8 h-8 rounded overflow-hidden">
              <img src="/founderboard-logo.png" alt="Founderboard" className="w-full h-full object-contain" />
            </div>
            <h1 className="text-2xl font-heading font-bold text-text-primary">Founderboard</h1>
          </div>
          <h2 className="text-3xl font-heading font-bold text-text-primary mb-2">Choose a new password</h2>
          <p className="text-text-secondary">8+ characters. Make it count.</p>
        </div>

        <form onSubmit={handleSubmit} className="bg-surface border border-border rounded-[10px] p-6 space-y-4" data-testid="reset-form">
          <div>
            <label className="block text-xs uppercase tracking-wider text-text-secondary mb-2">New password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full bg-background border border-border rounded-lg px-4 py-3 text-text-primary focus:outline-none focus:border-primary"
              placeholder="••••••••"
              required
              minLength={8}
              data-testid="reset-password-input"
            />
          </div>
          <div>
            <label className="block text-xs uppercase tracking-wider text-text-secondary mb-2">Confirm password</label>
            <input
              type="password"
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
              className="w-full bg-background border border-border rounded-lg px-4 py-3 text-text-primary focus:outline-none focus:border-primary"
              placeholder="••••••••"
              required
              minLength={8}
              data-testid="reset-confirm-input"
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            className="w-full bg-primary text-white py-3 rounded-lg font-medium hover:bg-primary/90 transition-colors disabled:opacity-50"
            data-testid="reset-submit"
          >
            {loading ? 'Resetting…' : 'Reset password'}
          </button>
          <Link to="/login" className="block text-center text-sm text-text-secondary hover:text-primary">← Back to login</Link>
        </form>
      </div>
    </div>
  );
};

export default ResetPassword;
